import { useLang } from "../i18n";

export default function SiempriaCredit({ dark = false, className = "" }) {
  const { t } = useLang();
  return (
    <div className={`flex items-center justify-center py-6 ${className}`}>
      <a href="https://siempria.com" target="_blank" rel="noopener noreferrer" data-testid="siempria-credit"
        className="flex items-center gap-2 group">
        <span className={`text-xs transition-colors ${dark ? "text-zinc-500 group-hover:text-zinc-300" : "text-topacio-faded group-hover:text-topacio-ink"}`}>
          {t.footer.developedBy}
        </span>
        <img src="/logo-siempria.png" alt="Siempria"
          className="h-7 w-auto opacity-80 group-hover:opacity-100 transition-opacity" />
      </a>
    </div>
  );
}
